/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateSubmittedBackfillResultDto } from '../models/DateSubmittedBackfillResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DateSubmittedBackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Dry run: reports what would change without writing.
     * @returns DateSubmittedBackfillResultDto OK
     * @throws ApiError
     */
    public preview(): CancelablePromise<DateSubmittedBackfillResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/DateSubmittedBackfill/Preview',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Applies the backfill reported by M:Compliance.Module.Housing.Controllers.DateSubmittedBackfillController.Preview.
     * @returns DateSubmittedBackfillResultDto OK
     * @throws ApiError
     */
    public run(): CancelablePromise<DateSubmittedBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/DateSubmittedBackfill/Run',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
